import React, { Component } from 'react';
import PropTypes from 'prop-types';

const richie = window.richie;
const AD_CONTENT_HOST = 'https://data.richie.app';

export function getAdUrl(prefix, uuid) {
  const url = `${AD_CONTENT_HOST}/${prefix}/${uuid}/content`;
  return url;
}

class RichieAdContainer extends Component {
  state = { adContainer: null };
  currentPos = 0;
  startPos = 0;

  constructor(props) {
    super(props);
    this.handleCreativeEvents = this.handleCreativeEvents.bind(this);
  }

  componentDidMount() {
    const uuid = this.props.uuid;
    if (process.env.NODE_ENV === 'development') {
      richie.setDebugMode(true);
    }
    richie.setPreviewMode(true);
    richie.init('fi.richie.html5.preview');
    richie.addEventListener('error', err => {
      if (this.props.onError) {
        this.props.onError(err);
      }
    });

    richie.addEventListener('analytics', evt => {
      if (typeof this.props.onAnalyticsEvent === 'function') {
        this.props.onAnalyticsEvent(evt);
      }
    });

    richie.addEventListener('ready', () => {
      if (typeof this.props.onReady === 'function') {
        this.props.onReady();
      }
    });
    const prefix = this.props.useProduction ? 'creative' : 'ads-preview';
    const url = getAdUrl(prefix, uuid);
    const adContainer = richie.getAdWithUrl(url);
    this.adContainerWrapper.appendChild(adContainer);
    this.adContainer = adContainer;

    this.setState({uuid: uuid, adContainer: adContainer});
    window.addEventListener('message', this.handleCreativeEvents, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleCreativeEvents, false);
    richie.destroy();
  }

  handleCreativeEvents(e) {
    if (typeof this.props.onCreativeEvent !== 'function') {
      return;
    }

    const payload = e.data;
    const {deltaX, deltaY, duration, notificationType} = payload;
    switch(notificationType) {
      case 'fi.richie.drag':
        this.props.onCreativeEvent('drag', {deltaX, deltaY, duration});
        break;
      case 'fi.richie.dragEnd':
        this.props.onCreativeEvent('dragEnd', {deltaX, deltaY, duration});
        break;
      case 'fi.richie.keyboardLeft':
      case 'fi.richie.keyboardRight':
      case 'fi.richie.keyboardSpace':
        this.props.onCreativeEvent(payload.notificationType.replace('fi.richie.', ''));
        break;
      default:
        break;
    }
  }

  adBecameVisible() {
    if (this.adContainer) {
      richie.adBecameVisible(this.adContainer, () => {
        richie.enableScrollingInAdContainer(this.adContainer, richie.ScrollingDirection.VERTICAL);
        this.props.onCreativeEvent('becameVisible');
      });
    }
  }

  adWasDismissed() {
    if (this.adContainer) {
      richie.adWasDismissed(this.adContainer);
      this.props.onCreativeEvent('wasDismissed');
    }
  }

  render() {
    return (
      <div style={{width: '100%', height: '100%'}} ref={(adContainer) => { this.adContainerWrapper = adContainer; }}></div>
    );
  }
}

RichieAdContainer.propTypes = {
  uuid: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onCreativeEvent: PropTypes.func,
  onAnalyticsEvent: PropTypes.func,
  onReady: PropTypes.func,
  useProduction: PropTypes.bool
};

export default RichieAdContainer;